import ExplorePage from "pages/ExplorePage";
import React from "react";

const ExploreRoute = () => <ExplorePage />;

export default ExploreRoute;
